<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> về </span>
    <span class="event">"{{ newsTitle }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      newsTitle: null,
      dataJson: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      let fromActor = this.dataJson.requester;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNEWS:
          action = "Thêm bản tin mới";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        default:
          break;
      }
      this.fromActorFullName = fromActor ? fromActor.fullName : "-";
      this.action = action;
      this.newsTitle = this.dataJson.news.title;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-news.vue